import type { ProjectConfig } from '../project'
import { tscheppaConfig } from './tscheppa'

/**
 * kaernten — die Kärnten-Grundkarte im EIGENEN Renderer (Subdomain kaernten.arkserver.arkturian.com, Rueckfall `?project=kaernten`).
 *
 * Anlass (Alex 2026-08-14): Das erste /kaernten-Demo lief auf Leaflet — „das
 * ist sicher nicht unser tilemap renderer, wtf warum nicht?" Zu Recht: Der
 * Beweis, dass die Quadtree-Basis taugt, zählt nur in der Engine, die sie
 * später trägt. Dieser Mieter rendert deshalb mit @apopovic77/tile-map im
 * OSM-Modus (Option B, Post 4242) — komplette Engine samt Pins, Ballons und
 * Routen, mit den echten Track-30-Daten auf der Kärnten-Basis.
 *
 * Kachelquelle: der eigene Baum unter /kaernten/tiles (map-capture-Werkzeug,
 * amtliches basemap.at-Orthofoto, CC-BY 4.0). GLEICHE Herkunft wie die App
 * selbst → kein CORS, kein fremder Kachelserver.
 *
 * Zoomfenster: volle Pyramide OSM 6–17 kärntenweit plus Tscheppa-Insel bis
 * z19 als detailArea — möglich seit dem faul instanziierenden TileManager
 * (canvas-engine 1.2 / tile-map 2.2, 2026-08-16). Das frühere Objektbudget-
 * Limit (ganz Kärnten bis z19 = 5,9 Mio. eifrige Objekte) ist Geschichte.
 */
export const kaerntenConfig: ProjectConfig = {
  ...tscheppaConfig,
  id: 'kaernten',
  name: 'Kärnten-Grundkarte (eigener Renderer)',

  map: {
    type: 'osm',
    center: { lat: 46.62, lng: 14.31 },
    defaultZoom: 0.5,
    backgroundColor: '#1a1a2e',
  },

  tileMap: {
    /* tscheppas tileMap ERBEN (routeStyle inkl. showOnlySelected — nur die
     * gewaehlte Route zeichnen —, Linienbreite, Casing, Physik): der fruehere
     * Voll-Ersatz warf das alles stumm weg, und die Karte zeigte ploetzlich
     * alle vier Routen (Alex 2026-08-16, Screenshot 119645). */
    ...tscheppaConfig.tileMap,
    /* tscheppas SVG-Overlays NICHT erben: ihre x/y sind Welt-Pixel des
     * Tscheppa-Fensters — im Kaernten-Fenster stuenden sie irgendwo. */
    svgOverlays: undefined,
    map: {
      type: 'osm',
      /* Die Kacheln sind NICHT OpenStreetMap — ohne diese Zeile stuende die
       * Vorgabe-Attribution der Engine unter einem amtlichen Orthofoto. */
      attribution: 'Orthofoto: basemap.at (CC-BY 4.0)',
      bounds: { minLat: 46.36, maxLat: 47.15, minLng: 12.65, maxLng: 15.06 },
      /* 1024er-Kacheln (kacheln1024.mjs): 16x weniger Anfragen je Sicht.
       * Die Zoom-Zahlen sind das 1024er-Raster: worldSize = 1024*2^Z, also
       * Z = OSM-z - 2. */
      tileUrlTemplate: 'https://kaernten.arkserver.arkturian.com/kaernten/tiles1024/{z}/{x}/{y}.jpg',
      tileSize: 1024,
      /* VOLLES Fenster Z4..Z15 = OSM 6..17 (tile-map >=2.2: Kacheln
       * materialisieren faul, das alte Objektbudget-Limit ist weg — das
       * Fenster ist reiner Adressraum). Die Uebersicht ist damit echte
       * Z4-Ebene statt heruntergerechneter Z10er. */
      minZoom: 4,
      maxZoom: 15,
      /* Variable Tiefe: die Tscheppa-Insel ist bis OSM z19 gebacken
       * (1024er-Raster Z17, kacheln1024 --von 18 --bis 19; Bounds = exakte
       * Ausdehnung des z19-Bestands). Der Welt-Pixelraum bemisst sich an der
       * TIEFSTEN Ebene — Kartenlaengen:Pins verhalten sich in der Schlucht
       * damit exakt wie im reinen Tscheppa-Projekt gleicher Tiefe (Alex
       * 2026-08-16: "Kaernten ist reingequetscht in einen Raum, der nur die
       * Tscheppaschlucht ausmacht"). Ausserhalb der Insel fragt die Engine
       * die fehlenden Tiefen-Kacheln dank coverage-Rects gar nicht erst an. */
      /* Gewaessernetz Kaernten (OSM via gewaesser-backen.mjs; Fluesse+Kanaele
       * komplett, Baeche mit Namen) — opt-in ueber den Legende-Toggle, die
       * 5-MB-Datei laedt erst beim ersten Einblenden. Gleiches Artefakt
       * liest die 3D-Terrain-Welt. */
      waterways: { url: 'https://kaernten.arkserver.arkturian.com/kaernten/tiles/gewaesser.json' },
      detailAreas: [
        {
          bounds: { minLat: 46.4643, maxLat: 46.4999, minLng: 14.2094, maxLng: 14.2885 },
          maxZoom: 17,
        },
      ],
    },
    view: {
      center: { lat: 46.62, lng: 14.31 },
      defaultZoom: 0.5,
      backgroundColor: '#1a1a2e',
    },
  },
}
